<template>
  <div class="main">
    <el-row>
      <el-col :span="12" style="border-right: 1px solid rgba(41, 155, 255, .2)">
        <el-row class="name">名称：{{ deviceInfo.name }}</el-row>
        <el-row style="margin-top: 20px;">
          <el-col :md="7" :sm="8" :xs="24"><span class="text-blueGrey">类型：</span>{{ deviceInfo.typeCnName }}</el-col>
          <el-col v-if="deviceShowBrand" :md="7" :sm="8" :xs="24"><span
            class="text-blueGrey">品牌：</span>{{ deviceInfo.brandCnName }}
          </el-col>
          <el-col v-if="deviceShowModel" :md="7" :sm="8" :xs="24"><span
            class="text-blueGrey">型号：</span>{{ deviceInfo.modelCnName }}
          </el-col>
          <el-col v-if="properties && properties.IP" :md="7" :sm="8" :xs="24"><span
            class="text-blueGrey">IP：</span><a :href="'http://'  + properties.IP" target="_blank">{{
              properties.IP
            }}</a>
          </el-col>
        </el-row>
        <el-row class="largeContent" style="margin-right: 10px;">
          <span class="text-blueGrey">备注：</span>{{ deviceInfo.note !== null ? deviceInfo.note : "-" }}
        </el-row>
        <!-- 运行时长 -->
        <el-row class="largeContent" style="margin-right: 10px;">
          <span class="text-blueGrey">运行时长：</span>{{ getRunningTime(deviceInfo.createTime) }}小时
        </el-row>
      </el-col>
      <el-col :span="12" v-if="statusShow">
        <el-row style="height: 45px;margin-top: 35px;" v-if="alarmInfoList.length > 0">
          <vue-seamless-scroll :class-option="classOption" :data="alarmInfoList" style="height: 100%;overflow:hidden;">
            <ul>
              <li :key="index" class="DataList_top" v-for="(item,index) in alarmInfoList">
                <el-row>
                  <el-col :span="5" class="level color">{{ item.levelName }}</el-col>
                  <el-col :span="18">
                    <el-row>{{ item.msg }}</el-row>
                    <el-row style="color: rgba(255, 255, 255, .5)">{{ item.createTime }}</el-row>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </vue-seamless-scroll>
        </el-row>
        <el-row style="text-align: center;padding: 40px 0;" v-else>
          <!-- 判断海康门禁开门状态 
                1: 开门状态
                2: 关门状态
                3: 离线状态
                4: 常闭
                5: 反锁
                6: 常开
                7: 常开
                8: 常闭 
          -->
          <div v-if="deviceInfo.detailUrl === 'HikDoor'">
          <span>门状态：</span>
          <span>{{doorStatusText}}</span>
          </div>
          <div v-else-if="deviceInfo.detailUrl === 'DasDoor'" style="margin-left: 80px;">
          <!-- <div v-else style="margin-left: 80px;"> -->
            <el-row style="text-align: left;transform: translateY(50%);">
              <el-col style="margin-bottom: 5px;" :span="24"> <span  class="text-blueGrey">设备状态：</span>{{dasDoorOnlineStatusText}}</el-col>
              <el-col :span="8"> <span  class="text-blueGrey">门锁状态：</span>{{dasDoorLockStatusText}}</el-col>
              <el-col :span="8"> <span  class="text-blueGrey">门磁状态：</span>{{dasDoorMagnetStatusText}}</el-col>
              <el-col :span="8"><span  class="text-blueGrey">门状态：</span>{{dasDoorStatusText}}</el-col>
            </el-row>
          </div>
          <div v-else>
            <span style="color: #15DEB5" v-if="deviceInfo.status === 0">设备运行正常</span>
            <span style="color: red" v-else>设备运行异常</span>
          </div>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import vueSeamlessScroll from 'vue-seamless-scroll'
import {getSystematicByCodes} from "@/network/systematic";

export default {
  name: "DeviceDetailDialogHeader",
  components: {vueSeamlessScroll},
  props: {
    deviceInfo: {
      type: Object,
      default: () => {
      }
    },
    alarmInfoList: {
      type: Array,
      default: () => []
    },
    statusShow: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      deviceShowBrand: true,
      deviceShowModel: true,
      properties: {},
    }
  },
  watch: {
    deviceInfo() {
      this.setDeviceProperties()
    }
  },
  methods: {
    setDeviceProperties() {
      if (this.deviceInfo && this.deviceInfo.portProperties) {
        this.properties = JSON.parse(this.deviceInfo.portProperties)
      } else {
        this.properties = {}
      }
    },
    // 根据创建时间计算今日运行时长
    getRunningTime(createTime) {
      const createDate = new Date(createTime)
      const now = new Date()
      const diffTime = now.getTime() - createDate.getTime()
      const diffHours = Math.floor(diffTime / 1000 / 3600)
      return diffHours
    },
  },
  
  mounted() {
    this.setDeviceProperties()
    getSystematicByCodes(['dcim_device_show_brand', 'dcim_device_show_model']).then(res => {
      if (res.code === 0) {
        res.data.forEach(item => {
          if (item.code === 'dcim_device_show_brand') {
            this.deviceShowBrand = item.val1 === 'true'
          } else if (item.code === 'dcim_device_show_model') {
            this.deviceShowModel = item.val1 === 'true'
          }
        })
      }
    })
  },
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: this.alarmInfoList.length, //开始无缝滚动的数据量
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        // singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      };
    },
    // 海康门禁的状态
    doorStatusText() {
      const portProperties = JSON.parse(this.deviceInfo.portProperties);
      const statusMap = {
        1: "开门状态",
        2: "关门状态",
        3: "离线状态",
        4: "常闭",
        5: "反锁",
        6: "常开",
        7: "常开",
        8: "常闭",
      };
      return statusMap[portProperties.doorState] || "未知";
    },
    // 达实门的状态(门打开状态)
    dasDoorStatusText() {
    const portProperties = JSON.parse(this.deviceInfo.portProperties);
      const statusMap = {
        '-1': "未知",
        0: "关门",
        1: "开门",
      };
      return statusMap[portProperties.openState] || "未知";
   },
  //  达实门锁状态 "{"lockState":0,"sensorState":1,"openState":1}"
  dasDoorLockStatusText() {
    const portProperties = JSON.parse(this.deviceInfo.portProperties);
      const statusMap = {
        '-1': "未知",
        0: "闭合",
        1: "打开",
      };
      return statusMap[portProperties.lockState] || "未知";
    },
    dasDoorMagnetStatusText() {
      const portProperties = JSON.parse(this.deviceInfo.portProperties);
      const statusMap = {
          '-1': "未知",
          0: "闭合",
          1: "打开",
        };
        return statusMap[portProperties.sensorState] || "未知";
      },
    // 达实设备在线状态
    dasDoorOnlineStatusText() {
      const portProperties = JSON.parse(this.deviceInfo.portProperties);
      const statusMap = {
          '-1': "未知",
          0: "离线",
          1: "在线",
        };
        return statusMap[portProperties.onlineState] || "未知";
      },
  },
  // 达实门磁状态
}
</script>

<style scoped>
.main {
  padding: 10px 30px;
  background-color: rgba(41, 155, 255, .1);
}

.name {
  padding-top: 20px;
  font-weight: bold;
  color: #299BFF;
}

.color {
  text-align: right;
  padding-right: 15px;
  color: rgba(254, 219, 91, .8);
}

li {
  list-style: none;
  margin-top: 30px;
  height: 45px;
}
</style>
